/**
 * Dynamic PWA Hook
 * Loads tenant-specific PWA manifest and theme color
 */

import { useEffect } from 'react';
import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api-v1';

export function useDynamicPWA() {
  useEffect(() => {
    loadDynamicManifest();
    loadThemeColor();
  }, []);

  const loadDynamicManifest = () => {
    // Remove existing manifest link
    const existingManifest = document.querySelector('link[rel="manifest"]');
    if (existingManifest) {
      existingManifest.remove();
    }

    // Add dynamic manifest link
    const manifestLink = document.createElement('link');
    manifestLink.rel = 'manifest';
    manifestLink.href = `${API_URL}/pwa/manifest.json`;
    document.head.appendChild(manifestLink);

    console.log('[PWA] Dynamic manifest loaded');
  };

  const loadThemeColor = async () => {
    try {
      const response = await axios.get(`${API_URL}/pwa/theme-color`);
      const themeColor = response.data.themeColor;

      // Update theme-color meta tag
      let themeColorMeta = document.querySelector('meta[name="theme-color"]');
      if (!themeColorMeta) {
        themeColorMeta = document.createElement('meta');
        themeColorMeta.name = 'theme-color';
        document.head.appendChild(themeColorMeta);
      }
      themeColorMeta.content = themeColor;

      // Update apple-mobile-web-app-status-bar-style
      let appleMeta = document.querySelector('meta[name="apple-mobile-web-app-status-bar-style"]');
      if (!appleMeta) {
        appleMeta = document.createElement('meta');
        appleMeta.name = 'apple-mobile-web-app-status-bar-style';
        document.head.appendChild(appleMeta);
      }
      appleMeta.content = 'default';

      console.log('[PWA] Theme color updated:', themeColor);
    } catch (error) {
      console.error('[PWA] Failed to load theme color:', error);
    }
  };
}

export default useDynamicPWA;
